import { Nav, useCollapsible } from "playbook-ui";
import { TopLevelNavItem } from "./TopLevelNavItems";
import FlyingGhosts from "./FlyingGhosts";

const Sidebar = ({
  dark,
  collapsed = false,
  type,
  category,
  kit,
  kits_with_status,
  getting_started,
  design_guidelines,
  whats_new,
  icons,
  global_props_and_tokens,
}: any) => {
  
  // --------------Halloween only-----------------------------
  // Check if we're in October (from midnight Oct 1 through Oct 31)
  // Add special Halloween decorations during this month!
  const isHalloweenMonth = () => {
    const today = new Date();
    const month = today.getMonth(); // 0-indexed, so October is 9
    return month === 9;
  };
  // --------------------------------------------------------

  const transformKitsData = (kitsArray: any) => {
    return kitsArray.map((kit: any) => {
      // There's only one key per object, so we get the kit name and its components
      const kitName = Object.keys(kit)[0];
      const components = kit[kitName];
  
      // Filter out any components with status 'beta', then map to get their names
      const componentNames = components
        .filter(component => component.status !== 'beta')
        .map(component => component.name);
  
      return { [kitName]: componentNames };
    });
  };
  
  const kits = transformKitsData(kits_with_status);
  
  //hook into collapsible logic for all components nested nav items
  const collapsibles = kits.map(() => useCollapsible());

  //kits in alphabetical order
  kits.map((obj: {[key: string]: string[]}) => {
  
    const key = Object.keys(obj)[0];
    if (key === "advanced_table") return
    const orderedArray = obj[key].sort((a, b) => a.localeCompare(b));
    return { [key]: orderedArray };
  });

  return (
    <>
      {isHalloweenMonth() && <FlyingGhosts />}
      <Nav dark={dark} variant="bold" paddingTop="md">
        <TopLevelNavItem
          dark={dark}
          sidebarCollapsed={collapsed}
          type={type}
          kits={kits}
          kit={kit}
          category={category}
          collapsibles={collapsibles}
          getting_started={getting_started}
          design_guidelines={design_guidelines}
          whats_new={whats_new}
          icons={icons}
          global_props_and_tokens={global_props_and_tokens}
        />
      </Nav>
    </>
  );
};

export default Sidebar;
